/**
 * Légende des états d'une table, repliée par défaut (la maquette L06-03 la montre ; en service on la veut discrète).
 * Les états ne reposent jamais sur la couleur seule : chaque pastille porte son libellé, comme sur la table.
 */
import React, { useState } from 'react';
import { Info } from 'lucide-react';

const ETATS: { libelle: string; fond: string; texte: string; explication: string }[] = [
  { libelle: 'LIBRE', fond: 'var(--bg-soft)', texte: 'var(--text-secondary)', explication: 'Aucune réservation à l’heure du plan.' },
  { libelle: 'RÉSERVÉE', fond: '#7c3aed', texte: '#ffffff', explication: 'Une réservation est prévue sur cette table.' },
  { libelle: 'INSTALLÉE', fond: 'var(--pds-ok-fg)', texte: '#ffffff', explication: 'Les clients sont arrivés et installés.' },
  { libelle: 'EN COURS', fond: 'var(--pds-info-fg)', texte: '#ffffff', explication: 'Repas en cours (le minuteur indique les minutes écoulées).' },
  { libelle: 'À LIBÉRER', fond: 'var(--pds-warn-fg)', texte: '#ffffff', explication: 'Le temps prévu est dépassé.' },
  { libelle: 'À DÉBARRASSER', fond: 'var(--pds-warn-fg)', texte: '#ffffff', explication: 'Repas terminé : la table est à débarrasser.' },
  { libelle: 'BLOQUÉE', fond: 'var(--pds-danger-fg)', texte: '#ffffff', explication: 'Table indisponible (motif indiqué dans son menu).' },
  { libelle: 'CONFLIT', fond: 'var(--pds-danger-fg)', texte: '#ffffff', explication: 'Deux réservations se chevauchent sur cette table.' },
];

export const LegendeStatuts: React.FC = () => {
  const [ouverte, setOuverte] = useState<boolean>(false);
  return (
    <div>
      <button
        type="button"
        aria-expanded={ouverte}
        aria-controls="legende-statuts"
        onClick={() => setOuverte((v) => !v)}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-semibold text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer min-h-[28px]"
      >
        <Info className="w-3.5 h-3.5" aria-hidden="true" />
        <span>Légende</span>
      </button>
      {ouverte && (
        <ul id="legende-statuts" className="absolute left-3 right-3 z-30 mt-2 p-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-lg grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 text-[11px] text-slate-600 dark:text-slate-300">
          {ETATS.map((e) => (
            <li key={e.libelle} className="flex items-center gap-2">
              <span className="inline-block min-w-[88px] text-center px-1.5 py-0.5 rounded text-[9px] font-bold tracking-wide" style={{ background: e.fond, color: e.texte, border: '1px solid var(--border-color)' }}>
                {e.libelle}
              </span>
              <span>{e.explication}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
